import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { DownloadIcon, CreditCardIcon } from 'lucide-react';
import { trackAddToCartAndRedirect } from '../lib/metaPixel';
export function PricingSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const goToCheckout = () => {
    trackAddToCartAndRedirect('https://www.legadosalud.com/cart/42499535011925:1', {
      content_name: 'El Protocolo Meno-Metabólico',
      content_ids: ['42499535011925'],
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
  };
  return <section id="pricing" ref={ref} className="py-16 md:py-24 bg-white scroll-mt-24" data-id="element-120">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-122">
          <div className="bg-gradient-to-br from-[#faf6ee] to-[#f5f0e6] rounded-2xl p-8 md:p-12 shadow-2xl border-2 border-[#c9a961]" data-id="element-123">
            <p className="text-lg md:text-xl text-[#2d2d2d] text-center mb-8 leading-relaxed" data-id="element-124">
              Normalmente este programa tiene un costo de $37 USD. Pero quiero
              que sea accesible para todas las mujeres que necesitan un cambio
              real hoy mismo.
            </p>

            <div className="text-center mb-8" data-id="element-125">
              <p className="text-xl md:text-2xl text-[#7a8a6b] font-semibold mb-4" data-id="element-126">
                ADQUIÉRELO HOY POR SOLO:
              </p>

              <div className="flex items-center justify-center gap-4 mb-6" data-id="element-127">
                <span className="text-2xl md:text-3xl text-[#7a8a6b] line-through opacity-60" data-id="element-128">
                  $37 USD
                </span>
                <span className="font-serif text-5xl md:text-6xl text-[#5d6e4f] font-bold" data-id="element-129">
                  $6,39 USD
                </span>
              </div>

              <div className="flex items-center justify-center gap-2 text-[#7a8a6b] mb-8" data-id="element-130">
                <CreditCardIcon className="w-5 h-5" data-id="element-131" />
                <p className="text-base md:text-lg" data-id="element-132">
                  Pago único. Descarga inmediata a tu celular, tablet o
                  computadora.
                </p>
              </div>
            </div>

            <motion.button onClick={goToCheckout} whileHover={{
            scale: 1.05,
            y: -2
          }} whileTap={{
            scale: 0.98
          }} className="w-full bg-[#5d6e4f] text-white px-10 py-5 rounded-lg text-xl font-semibold shadow-lg hover:bg-[#4a5940] transition-colors flex items-center justify-center gap-3" data-id="element-133">
              <DownloadIcon className="w-6 h-6" data-id="element-134" />
              DESCÁRGALO AHORA POR $6,39 USD
            </motion.button>
          </div>
        </motion.div>
      </div>
    </section>;
}